const SET_SELECTED_CLASS_EVALUATION_DOMAINS = 'evaluations/SET_SELECTED_CLASS_EVALUATION_DOMAINS';
const SET_CLASS_EVALUATION_DOMAINS = 'evaluations/SET_CLASS_EVALUATION_DOMAINS';
const SET_EVALUATION_ORDER_BY = 'evaluations/SET_EVALUATION_ORDER_BY';
const SET_EVALUATION_CRITERIA = 'evaluations/SET_EVALUATION_CRITERIA';
const SET_EVALUATION_FILTER = 'evaluations/SET_EVALUATION_FILTER';
const SET_EVALUATION_LIST = 'evaluations/SET_EVALUATION_LIST';
const SET_EVALUATION = 'evaluations/SET_EVALUATION';

export default {
  SET_SELECTED_CLASS_EVALUATION_DOMAINS,
  SET_CLASS_EVALUATION_DOMAINS,
  SET_EVALUATION_ORDER_BY,
  SET_EVALUATION_CRITERIA,
  SET_EVALUATION_FILTER,
  SET_EVALUATION_LIST,
  SET_EVALUATION,
};



// WEBPACK FOOTER //
// ./src/app/evaluations/store/mutation-types.js